import * as Yup from "yup";

// const phoneRegExp = /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
const mobileRegex = /^(\+92\d{10}|03\d{9})$/;
const cnicRegex = /^\d{5}-\d{7}-\d{1}$/;
const parameterValueRegex = /^[a-zA-Z]+$/;
const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const loginSchema = Yup.object({
    userId: Yup.string().required('Please enter your ID'),
    password: Yup.string().min(8).required('Please enter your password')
});

export const otpSchema = Yup.object({
    otp: Yup.string().min(6).required('Please enter your OTP code'),
    otpType: Yup.string().required('Please select otp type')
});

export const userSchema = ({ isChecker, fromMakerChecker, is2FA }) => Yup.object({
    ...(!isChecker && {
        userId: Yup.string()
            .matches(/^[a-zA-Z0-9]+$/, 'Special characters and spaces not allowed')
            .min(8, 'Minimum 8 characters required')
            .max(16, 'Maximum 16 characters allowed')
            .required('User ID is required!'),
        institution: Yup.string().required('Please select institution'),
        name: Yup.string()
            .matches(/^[A-Za-z\s]+$/, 'Only letters and spaces are allowed')
            .min(2, 'Minimum 2 characters required')
            .max(50, 'Maximum 50 characters allowed')
            .required('Please enter user name'),
        cnic: Yup.string().matches(cnicRegex, 'Invalid CNIC format. Correct format: XXXXX-XXXXXXX-X').required('Please enter CNIC'),
        mobileNo: Yup.string().matches(mobileRegex, 'Invalid mobile number format. Correct formats: 03XXXXXXXXX or +923XXXXXXXXX').required('Please enter mobile number'),
        email: Yup.string()
            .matches(emailRegex, 'Invalid email format')
            .max(50, 'Maximum 50 characters allowed')
            .required('Please enter email'),
        empNumber: Yup.string()
            .matches(/^[a-zA-Z0-9]+$/, 'Special characters and spaces not allowed')
            .min(2, 'Minimum 2 characters required')
            .max(8, 'Maximum 8 characters allowed')
            .required('Employee number is required!'),
        department: Yup.string()
            .matches(/^[a-zA-Z0-9 ]+$/, 'Only letters, numbers, and spaces are allowed')
            .min(5)
            .max(100, 'Maximum 100 characters allowed')
            .required('Please enter department'),
        designation: Yup.string()
            .matches(/^[a-zA-Z0-9 ]+$/, 'Only letters, numbers, and spaces are allowed')
            .min(5)
            .max(100, 'Maximum 100 characters allowed')
            .required('Please enter designation'),
        // remarks: Yup.string(),
        is2FAEnable: Yup.boolean(),
        forgotPassword: Yup.boolean(),
        ...(is2FA ? {
            otpType: Yup.string().required('Please select OTP type'),
        } : {
            otpType: Yup.string(),
        }),
        userStatus: Yup.string().required('Please select status'),
        role: Yup.string().required('Please select role'),
    }),
    ...(fromMakerChecker && {
        reason: Yup.string().required('Please enter you reason'),
    })
});

export const roleSchema = ({ isChecker, fromMakerChecker }) => Yup.object({
    ...(!isChecker && {
        // code: Yup.string()
        //     .matches(/^[a-zA-Z0-9]+$/, 'Special characters and spaces not allowed')
        //     .min(2, 'Minimum 2 characters required')
        //     .max(8, 'Maximum 8 characters allowed')
        //     .required('Please set a code'),
        descr: Yup.string().matches(/^[a-zA-Z\s]{1,20}$/, 'Only letters are allowed, max 20 characters').required('Please enter name'),
        roleStatus: Yup.string().required('Please select status'),
        institution: Yup.string().required('Please select institution'),
    }),
    ...(fromMakerChecker && {
        reason: Yup.string().required('Please enter you reason'),
    })
});

export const changePasswordSchema = Yup.object({
    password: Yup.string().required('Please enter your old password'),
    newPassword: Yup.string().min(8).required('Please set new password').matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/, // eslint-disable-line no-useless-escape
        "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
    ),
    confirmPassword: Yup.string().required('Please confirm your new password').oneOf([Yup.ref('newPassword'), null], 'Password must match')
});

export const participantSchema = ({ isChecker, fromMakerChecker, conditionalRegex }) => Yup.object({
    ...(!isChecker && {
        ...(!fromMakerChecker && {
            participantName: Yup.string().matches(/^[a-zA-Z\s]{1,50}$/, 'Only letters are allowed, max 50 characters').required('Please enter participant full name'),
            // participantType: Yup.string().required('Please select participant type'),
        }),
        primaryPersonName: Yup.string().matches(/^[a-zA-Z\s]{1,20}$/, 'Only letters are allowed, max 20 characters').required('Please enter name'),
        primaryPersonEmail: Yup.string().matches(emailRegex, 'Invalid email format').required('Please enter email'),
        primaryPersonPhone: Yup.string()
            .matches(mobileRegex, 'Invalid mobile number format. Correct formats: 03XXXXXXXXX or +923XXXXXXXXX')
            .required('Mobile number is required'),
        secondaryPersonName: Yup.string().matches(/^[a-zA-Z\s]{1,20}$/, 'Only letters are allowed, max 20 characters').required('Please enter name'),
        secondaryPersonEmail: Yup.string()
            .matches(emailRegex, 'Invalid email format')
            .required('Please enter email')
            .notOneOf([Yup.ref('primaryPersonEmail')], 'Secondary email must be different from primary email'),
        secondaryPersonPhone: Yup.string()
            .matches(mobileRegex, 'Invalid mobile number format. Correct formats: 03XXXXXXXXX or +923XXXXXXXXX')
            .required('Mobile number is required')
            .notOneOf([Yup.ref('primaryPersonPhone')], 'Secondary phone must be different from primary phone'),
        logoSize: Yup.string().required('Please select logo size'),
        logoFormat: Yup.string().required('Please select logo format'),
        participantLogo: Yup.mixed().required('Image is required'),
        cardValidator: Yup.string().required('Please select card validator'),
        authenticationTypeId: Yup.string().required('Please select authentication type'),
        otpValidityId: Yup.string().required('Please select OTP validity'),
        otpCharacteristicsId: Yup.string().required('Please select OTP scheme'),
        otpDeliveries: Yup.array().required('OTP medium is required').min(1, 'At least one OTP medium is required'),
        customerCanSelectAuthMethod: Yup.boolean(),
        isMultiLanguageSupport: Yup.boolean(),
        // otpDeliveries: Yup.array()
        //     .test(
        //         'otpDeliveries',
        //         'OTP medium is required',
        //         function (value) {
        //             const { customerCanSelectAuthMethod } = this.parent;

        //             // If customerCanSelectAuthMethod is true, otpDeliveries must not be empty
        //             if (customerCanSelectAuthMethod && (!value || value.length === 0)) {
        //                 return this.createError({
        //                     message: 'At least one OTP medium is required',
        //                 });
        //             }

        //             // If customerCanSelectAuthMethod is false, no validation is needed
        //             return true;
        //         }
        //     ),
        smsVenderId: Yup.string().required('Please select OTP service provider'),
        smsTemplate: conditionalRegex?.hasSmsDelivery ? Yup.string().required('Please set template for SMS') : Yup.string(),
        senderEmail: conditionalRegex?.hasEmailDelivery ? Yup.string().matches(emailRegex, 'Invalid email format').required('Please enter sender email') : Yup.string().matches(emailRegex, 'Invalid email format'),
        emailSubject: conditionalRegex?.hasEmailDelivery ? Yup.string().required('Please set subject for email') : Yup.string(),
        emailTemplate: conditionalRegex?.hasEmailDelivery ? Yup.string().required('Please set template for email') : Yup.string(),
        addParticipantBinRangeDto: Yup.array().of(
            Yup.object().shape({
                schemeId: Yup.string().required('Scheme ID is required'),
                bin: Yup.string()
                    .matches(/^[0-9]+$/, 'Only numbers are allowed')
                    .matches(/^\d{6}(\d{2})?$/, 'BIN must be a numeric value with 6 or 8 digits')
                    .required('BIN is required'),
                // ica: Yup.string()
                //     .matches(/^[0-9]+$/, 'Only numbers are allowed')
                //     .matches(/^\d{6}(\d{2})?$/, 'ICA must be a numeric value with 6 or 8 digits')
                //     .required('ICA is required')
                //     .test('not-same-as-bin', 'ICA cannot be same as BIN', function (value) {
                //         return value !== this.parent.bin;
                //     }),
                binStartRange: Yup.string()
                    .matches(/^[0-9]+$/, 'Only numbers are allowed')
                    .required('Card Range Start is required')
                    .test(
                        'binStartRange',
                        function (value) {
                            const {
                                bin,
                                // binEndRange
                            } = this.parent;
                            if (value?.length > 0 && bin?.length === 6 && !/^\d{9}$/.test(value)) {
                                return this.createError({ message: 'Card range start must be a numeric value with 9 digits when BIN length is 6' });
                            }
                            if (value?.length > 0 && bin?.length === 8 && !/^\d{7}$/.test(value)) {
                                return this.createError({ message: 'Card range start must be a numeric value with 7 digits when BIN length is 8' });
                            }
                            // if (binEndRange && parseInt(value) >= parseInt(binEndRange)) {
                            //     return this.createError({ message: 'Start range must be less than end range' });
                            // }
                            return true;
                        }
                    ),

                binEndRange: Yup.string()
                    .matches(/^[0-9]+$/, 'Only numbers are allowed')
                    .required('Card Range End is required')
                    .test(
                        'binEndRange',
                        function (value) {
                            const { bin, binStartRange } = this.parent;
                            if (value?.length > 0 && bin?.length === 6 && !/^\d{9}$/.test(value)) {
                                return this.createError({ message: 'Card range end must be a numeric value with 9 digits when BIN length is 6' });
                            }
                            if (value?.length > 0 && bin?.length === 8 && !/^\d{7}$/.test(value)) {
                                return this.createError({ message: 'Card range end must be a numeric value with 7 digits when BIN length is 8' });
                            }
                            if (binStartRange && parseInt(value) <= parseInt(binStartRange)) {
                                return this.createError({ message: 'Range End must be greater than Range Start' });
                            }
                            return true;
                        }
                    ),
                // currencies: Yup.array().required('Currencies is required').min(1, 'At least one currency is required'),
            })
        ).min(1, 'At least one BIN range is required'),
    }),
    ...(fromMakerChecker && {
        reason: Yup.string().required('Please enter you reason'),
    })
});

export const acsParameterSchema = ({ isChecker, fromMakerChecker, selectedAcsParamRegex }) => Yup.object({
    ...(!isChecker && {
        // institutionId: Yup.string().required('Please select a participant'),
        schemeId: Yup.string().required('Please select a scheme'),
        acsParametersId: Yup.string().required('Please select parameter'),
        parameterValue: Yup.string().matches(selectedAcsParamRegex || parameterValueRegex, `Valid regex: ${selectedAcsParamRegex || parameterValueRegex}`).required('Please enter parameter value'),
        // parameterValue: Yup.string().matches(/^0[0-9]{1}$/, 'Invalid parameter value').required('Please enter parameter value'),
        dsConfigurationId: Yup.string().required('Please select directory server'),
        messageInclusionId: Yup.string().required('Please select message type'),
        messageVersionId: Yup.string().required('Please select a version'),
        effectiveDateTime: Yup.string().required('Please set effective date time'),
    }),
    ...(fromMakerChecker && {
        reason: Yup.string().required('Please enter you reason'),
    })
});

export const ruleEngineSchema = ({ fromMakerChecker, isChecker }) => Yup.object({
    ...(!isChecker && {
        institution: Yup.string().required('Please select institution'),
        configurations: Yup.array().of(ruleConfigurationSchema({ fromMakerChecker })),
    }),
    ...(fromMakerChecker && {
        reason: Yup.string().required('Please enter your reason'),
    })
});

export const ruleConfigurationSchema = ({ fromMakerChecker }) =>
    Yup.object({
        // General fields
        scheme: Yup.array(),
        bins: Yup.array()
            .required("Please select bins")
            .min(1, "At least one bin should be selected"),

        // Transaction History - Low Activity
        numberOfSuccessfullTransactionLow: Yup.string()
            .matches(/^[0-9]+$/, "Only numbers are allowed")
            .test("positive-number", "At least one transaction required", (value) => value && parseInt(value) > 0,)
            .required("Number of successful transactions required"),

        // Transaction History - Medium Activity
        numberOfSuccessfullTransactionMedium: Yup.string()
            .matches(/^[0-9]+$/, "Only numbers are allowed")
            .test("positive-number", "Value must be greater than 0", (value) => value && parseInt(value) > 0)
            .test(
                "less-than-low",
                "Medium Activity must be Less than Low Activity",
                function (value) {
                    const { numberOfSuccessfullTransactionLow } = this.parent;
                    if (!value || !numberOfSuccessfullTransactionLow) return true; // skip if one is empty
                    return parseInt(value) < parseInt(numberOfSuccessfullTransactionLow);
                }
            )
            .required("Number of successful transactions required"),

        // Transaction History - High Activity
        numberOfSuccessfullTransactionHigh: Yup.string()
            .matches(/^[0-9]+$/, "Only numbers are allowed")
            .test("positive-number", "Value must be greater than 0", (value) => value && parseInt(value) > 0)
            .test(
                "less-than-medium",
                "High Activity must be Less than Medium Activity",
                function (value) {
                    const { numberOfSuccessfullTransactionMedium } = this.parent;
                    if (!value || !numberOfSuccessfullTransactionMedium) return true;
                    return parseInt(value) < parseInt(numberOfSuccessfullTransactionMedium);
                }
            )
            .required("Number of successful transactions required"),

        numberOfDaysLow: Yup.string()
            .matches(/^[0-9]+$/, "Only numbers are allowed")
            .test("positive-number", "At least one day required", (value) => value && parseInt(value) > 0)
            .required("Number of days required"),

        numberOfSuccessfullTransactionLowScore: Yup.number()
            .min(1, "Minimum score must be greater than 0")
            .max(100, "Maximum score is 100")
            .required("Lookback period score required"),

        numberOfSuccessfullTransactionMediumScore: Yup.number()
            .min(1, "Minimum score must be greater than 0")
            .max(100, "Maximum score is 100")
            .required("Lookback period score required"),

        numberOfSuccessfullTransactionHighScore: Yup.number()
            .min(1, "Minimum score must be greater than 0")
            .max(100, "Maximum score is 100")
            .required("Lookback period score required"),

        // Purchase Amounts
        purchaseAmountLow: Yup.string()
            .matches(/^[0-9]+$/, "Only numbers are allowed")
            .test("positive-number", "Value must be greater than 0", (value) => value && parseInt(value) > 0)
            .required("Purchase amount required"),

        // Purchase Amount (Medium)
        purchaseAmountMedium: Yup.string()
            .matches(/^[0-9]+$/, "Only numbers are allowed")
            .test("positive-number", "Value must be greater than 0", (value) => value && parseInt(value) > 0)
            .test(
                "greater-than-low",
                "Medium amount must be greater than Low amount",
                function (value) {
                    const { purchaseAmountLow } = this.parent;
                    if (!value || !purchaseAmountLow) return true; // skip if one is empty
                    return parseInt(value) > parseInt(purchaseAmountLow);
                }
            )
            .required("Purchase amount required"),

        // Purchase Amount (High)
        purchaseAmountHigh: Yup.string()
            .matches(/^[0-9]+$/, "Only numbers are allowed")
            .test("positive-number", "Value must be greater than 0", (value) => value && parseInt(value) > 0)
            .test(
                "greater-than-medium",
                "High amount must be greater than Medium amount",
                function (value) {
                    const { purchaseAmountMedium } = this.parent;
                    if (!value || !purchaseAmountMedium) return true;
                    return parseInt(value) > parseInt(purchaseAmountMedium);
                }
            )
            .required("Purchase amount required"),

        // Purchase Amount Scores
        purchaseAmountLowScore: Yup.number()
            .min(1, "Minimum score must be greater than 0")
            .max(100, "Maximum score is 100")
            .required("Purchase amount (low) score required"),

        purchaseAmountMediumScore: Yup.number()
            .min(1, "Minimum score must be greater than 0")
            .max(100, "Maximum score is 100")
            .required("Purchase amount (medium) score required"),

        purchaseAmountHighScore: Yup.number()
            .min(1, "Minimum score must be greater than 0")
            .max(100, "Maximum score is 100")
            .required("Purchase amount (high) score required"),

        // Device Fingerprint Score
        deviceFingerPrintScore: Yup.number()
            .min(1, "Minimum score must be greater than 0")
            .max(100, "Maximum score is 100")
            .required("Device fingerprint score required"),

        // Currencies
        currencies: Yup.array()
            .of(Yup.string().required("Currency is required"))
            .min(1, "At least one currency must be selected")
            .required("Currencies are required"),

        // Currency Code Score
        currencyCodeScore: Yup.number()
            .min(1, "Minimum score must be greater than 0")
            .max(100, "Maximum score is 100")
            .required("Currency code score required"),

        currencyCodeWeitage: Yup.number()
            .min(1, "Weightage must be greater than 0")
            .required("Enter currency code weightage"),

        deviceFingerPrintWeitage: Yup.number()
            .min(1, "Weightage must be greater than 0")
            .required("Enter device fingerprint weightage"),

        numberOfSuccessfullTransactionWeitage: Yup.number()
            .min(1, "Weightage must be greater than 0")
            .required("Enter transaction history weightage"),

        purchaseAmountWeitage: Yup.number()
            .min(1, "Weightage must be greater than 0")
            .required("Enter amount threshold weightage")
            .test("total-weightage", "Total weightage must be exactly 100", function (value) {
                const {
                    currencyCodeWeitage = 0,
                    deviceFingerPrintWeitage = 0,
                    numberOfSuccessfullTransactionWeitage = 0,
                    purchaseAmountWeitage = 0,
                } = this.parent;

                const total =
                    Number(currencyCodeWeitage || 0) +
                    Number(deviceFingerPrintWeitage || 0) +
                    Number(numberOfSuccessfullTransactionWeitage || 0) +
                    Number(purchaseAmountWeitage || 0);

                return total === 100;
            }),
        frictionlessScoreThreshold: Yup.number()
            .min(1, "Minimum score must be greater than 0")
            .max(100, "Maximum score is 100")
            .required("Frictionless score threshold is required"),
        // update this if total weightage is less than 100 show error it always total is 100

        // Effective Date
        ...(fromMakerChecker
            ? {
                effectiveDateTime: Yup.string().required("Effective date is required"),
            }
            : {
                effectiveDateTime: Yup.string()
                    .required("Effective date is required")
                    .test(
                        "is-future-date",
                        "Effective date must be greater than today",
                        function (value) {
                            const today = new Date();
                            today.setHours(23, 59, 59, 999);
                            const selectedDate = new Date(value);
                            return selectedDate > today;
                        }
                    ),
            }),
    })
// Add total weightage validation here
//      .test(
//     "total-weightage",
//     "Total of all weightages must not exceed 100",
//     function (values) {
//       if (!values) return true;

//       const {
//         currencyCode = "0",
//         deviceFingerPrint = "0",
//         numberOfSuccessfullTransaction = "0",
//         purchaseAmount = "0",
//       } = values;

//       const total =
//         Number(currencyCode || 0) +
//         Number(deviceFingerPrint || 0) +
//         Number(numberOfSuccessfullTransaction || 0) +
//         Number(purchaseAmount || 0);

//       return total <= 100;
//     }
//   );



export const mccBlockSchema = ({ fromParticipantlevel, fromMakerChecker }) => Yup.object({
    merchants: Yup.array().required('Please select at least one merchant').min(1, 'At least one merchant is required'),
    // effectiveDate: Yup.string()
    //     .required('Effective date is required')
    //     .test(
    //         'is-future-date',
    //         'Effective date must be greater than today',
    //         function(value) {
    //             const today = new Date();
    //             today.setHours(23, 59, 59, 999);
    //             const selectedDate = new Date(value);
    //             return selectedDate > today;
    //         }
    //     ),
    ...(fromParticipantlevel && {
        institutionCode: Yup.string().required('Please select institution'),
    }),
    ...(fromMakerChecker ? {
        effectiveDate: Yup.string().required('Effective date is required'),
        reason: Yup.string().required('Please enter your reason'),
    } : {
        effectiveDate: Yup.string()
            .required('Effective date is required')
            .test(
                'is-future-date',
                'Effective date must be greater than today',
                function (value) {
                    const today = new Date();
                    today.setHours(23, 59, 59, 999);
                    const selectedDate = new Date(value);
                    return selectedDate > today;
                }
            ),
    })
});

export const countryCodeBlockSchema = ({ fromParticipantlevel, fromMakerChecker }) => Yup.object({
    countries: Yup.array().required('Please select at least one country code').min(1, 'At least one country code is required'),
    ...(fromParticipantlevel && {
        institutionCode: Yup.string().required('Please select institution'),
    }),
    ...(fromMakerChecker
        ? {
            effectiveDate: Yup.string().required('Effective date is required'),
            reason: Yup.string().required('Please enter your reason'),
        }
        : {
            effectiveDate: Yup.string()
                .required('Effective date is required')
                .test(
                    'is-future-date',
                    'Effective date must be greater than today',
                    function (value) {
                        const today = new Date();
                        today.setHours(23, 59, 59, 999);
                        const selectedDate = new Date(value);
                        return selectedDate > today;
                    }
                ),
        }
    )
});

export const apiConfigurationSchema = ({ fromMakerChecker, isChecker }) => Yup.object({
    cardInquiry: Yup.array().of(apiConfigurationFieldSchema({ fromMakerChecker, isChecker }))
        .min(1, 'At least one card inquiry configuration is required')
        .max(20, 'Maximum 20 card inquiry configurations allowed'),
    otpGenerator: Yup.array().of(apiConfigurationFieldWithOTPSchema({ fromMakerChecker, isChecker }))
        // .min(1, 'At least one OTP generator configuration is required')
        .max(20, 'Maximum 20 OTP generator configurations allowed'),
    otpValidator: Yup.array().of(apiConfigurationFieldSchema({ fromMakerChecker, isChecker }))
        .max(20, 'Maximum 20 OTP validator configurations allowed'),
    ...(fromMakerChecker && {
        reason: Yup.string().required('Please enter your reason'),
    })
});

export const apiConfigurationFieldSchema = ({ isChecker }) => Yup.object({
    apiName: Yup.string(),
    apiType: Yup.string().required('Please set api type'),
    attributeField: Yup.string().required('Please set attribute name field type'),
    isDatetimeField: Yup.boolean(),
    attributeValue: Yup.string(),
    otpDelivery: Yup.string(),
    ...(isChecker ? {
        attributeName: Yup.string()
            .required('Please set attribute name'),
        ordering: Yup.string().required('Please set ordering'),
    } : {
        attributeName: Yup.string()
            .matches(/^[a-zA-Z0-9]+$/, 'Special characters and spaces not allowed')
            .required('Please set attribute name'),
        ordering: Yup.string()
            .required('Please set ordering')
            .matches(/^[1-9]$|^1[0-9]$|^20$/, 'Ordering must be a number from 1 to 20'),
    })
});

export const apiConfigurationFieldWithOTPSchema = ({ isChecker }) => Yup.object({
    apiName: Yup.string(),
    apiType: Yup.string().required('Please set api type'),
    attributeField: Yup.string().required('Please set attribute name field type'),
    attributeName: Yup.string()
        .matches(/^[a-zA-Z0-9]+$/, 'Special characters and spaces not allowed')
        .required('Please set attribute name'),
    isDatetimeField: Yup.boolean(),
    attributeValue: Yup.string(),
    otpDelivery: Yup.string().required('Please select OTP delivery'),
    ...(isChecker ? {
        attributeName: Yup.string()
            .required('Please set attribute name'),
        ordering: Yup.string().required('Please set ordering'),
    } : {
        attributeName: Yup.string()
            .matches(/^[a-zA-Z0-9]+$/, 'Special characters and spaces not allowed')
            .required('Please set attribute name'),
        ordering: Yup.string()
            .required('Please set ordering')
            .matches(/^[1-9]$|^1[0-9]$|^20$/, 'Ordering must be a number from 1 to 20'),
    })
});